import React, { useEffect, useState } from 'react'
import { Paper, Typography, Box } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import api from '../../api/client'
import { toFarsiDigits } from '../../assets/utils'

/** کارتابل پیمانکار: کارهای بازی که باید انجام دهد (فیش بیمه، گزارش تأخیر برگشتی). */
const CartableCard = () => {
    const [items, setItems] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        let alive = true
        api.get('users/cartable/')
            .then((r) => { if (alive) setItems((r.data && r.data.items) || []) })
            .catch(() => {})
        return () => { alive = false }
    }, [])

    if (!items.length) return null

    return (
        <Paper elevation={1} style={{ margin: '12px 0', padding: 14, borderRadius: 12, direction: 'rtl' }}>
            <Typography style={{ fontWeight: 800, fontSize: 15, marginBottom: 10, color: '#0f172a' }}>
                کارتابل من
            </Typography>
            <Box display='flex' style={{ gap: 10, flexWrap: 'wrap' }}>
                {items.map((it) => (
                    <Box
                        key={it.key}
                        onClick={() => navigate(it.link)}
                        style={{
                            cursor: 'pointer',
                            background: it.key === 'insurance' ? '#ecfdf5' : '#fff7ed',
                            border: '1px solid ' + (it.key === 'insurance' ? '#6ee7b7' : '#fdba74'),
                            borderRadius: 12,
                            padding: '10px 16px',
                            minWidth: 190,
                        }}
                    >
                        <Typography style={{ fontSize: 12.5, fontWeight: 700, color: it.key === 'insurance' ? '#065f46' : '#9a3412' }}>
                            {it.title}
                        </Typography>
                        <Typography style={{ fontSize: 24, fontWeight: 800, color: '#0f172a', lineHeight: 1.4 }}>
                            {toFarsiDigits(it.count)}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Paper>
    )
}

export default CartableCard
